import { render } from "./organizations.vue?vue&type=template&id=bdeee046"
import script from "./organizations.vue?vue&type=script&lang=js"
export * from "./organizations.vue?vue&type=script&lang=js"

import "./organizations.vue?vue&type=style&index=0&id=bdeee046&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__